export default {
      id: "btn_actu-usage",
      viewBox: "0 0 11 18",
      url: "../dist/images/" + "sprite.svg#btn_actu-usage",
      toString: function () {
        return this.url;
      }
    }